/*
 *
 * LanguageProvider reducer
 *
 */

import { CHANGE_LOCALE, SET_URGET_MODAL } from '../constants';
import { DEFAULT_LOCALE } from 'i18n';

export const initialState = {
  locale: DEFAULT_LOCALE,
  urgetModal: false
};

function languageProviderReducer(state = initialState, action) {
  switch (action.type) {
    case CHANGE_LOCALE:
      return { ...state, locale: action.locale };
    case SET_URGET_MODAL:
      return { ...state, urgetModal: true };
    default:
      return state;
  }
}

export default languageProviderReducer;
